import React, { memo } from 'react';
import PropTypes from 'prop-types';
import StepIndicator from './StepIndicator';
import './Stepper.css';

/**
 * Stepper Component
 * Displays a horizontal workflow stepper with visual indicators for current, completed, and pending stages
 */
const Stepper = memo(({ steps, currentStep, completedSteps }) => {
  return (
    <div className="stepper-container" aria-label={`Workflow progress: step ${currentStep} of ${steps.length}`}>
      <div className="stepper">
        {steps.map((step, index) => {
          const stepNumber = step.id;
          const isActive = stepNumber === currentStep;
          const isCompleted = completedSteps.has(stepNumber);
          const isLast = index === steps.length - 1;

          return (
            <StepIndicator
              key={step.id}
              stepNumber={stepNumber}
              label={step.label}
              description={step.description}
              isActive={isActive}
              isCompleted={isCompleted}
              isLast={isLast}
            />
          );
        })}
      </div>
    </div>
  );
});

Stepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  ).isRequired,
  currentStep: PropTypes.number.isRequired,
  completedSteps: PropTypes.instanceOf(Set).isRequired
};

export default Stepper;
